import React from "react";
import styles from "./styles.module.scss";
import Link from "../Link";

const Message = ({ value, consultationId }) => (
  <div className={styles.videoCapabilitiesMessage}>
    <div
      className={styles.videoCapabilitiesMessageValue}
      data-testid="video-capabilities-message-value"
    >
      {value}
    </div>

    <div className={styles.videoCapabilitiesLink}>
      <Link
        consultationId={consultationId}
      />
    </div>
  </div>
);

export default Message;
